import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import TypeMenuBlock from '../../Common/TypeMenuBlock';
import { setSameDaysCount, toggleEating } from '../../../actions/menu';
import ChooseEatings from '../../Common/ChooseEatings';

const GenerateOptions = ({
  selectedComplex,
  sameDaysCount,
  setSameDaysCount,
  toggleEating,
  chosenEatings,
  allEatingsTags,
}) => {
  return (
    <React.Fragment>
      <GenerateBlock>
        {selectedComplex && (
          <React.Fragment>
            <H1>
              Дата старта комплекса:{' '}
              {selectedComplex.start_date ? selectedComplex.start_date : 'Не назначена'}
            </H1>
            <NumberOfDaysToGenerate>
              Количество дней для генерации: {selectedComplex.period}
            </NumberOfDaysToGenerate>
          </React.Fragment>
        )}

        <TypeMenuBlock sameDaysCount={sameDaysCount} setSameDaysCount={setSameDaysCount} />

        <ChooseEatings
          eatings={allEatingsTags}
          chosenEatings={chosenEatings}
          toggleEating={toggleEating}
        />
      </GenerateBlock>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { users, showRewritePopup, rewriteAnswer, user } = state.reducers;
  const {
    sameDaysCount,
    selectedDayCount,
    chosenEatings,
    isShowConfirmPublishComplex,
    menu,
  } = state.menu;
  const { category } = state.setParams;
  const { loader } = state.loader;
  const { selectedComplex } = state.complex;
  const { tags, allEatingsTags } = state.getTags;
  return {
    users,
    user,
    category,
    sameDaysCount,
    selectedDayCount,
    showRewritePopup,
    rewriteAnswer,
    loader,
    selectedComplex,
    isShowConfirmPublishComplex,
    chosenEatings,
    tags,
    allEatingsTags,
    menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSameDaysCount: (daysCount) => {
      dispatch(setSameDaysCount(daysCount));
    },
    toggleEating: (tagId) => {
      dispatch(toggleEating(tagId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenerateOptions);

const GenerateBlock = styled.div`
  display: inline-block;
  margin: 10px auto 0;
  height: auto;
`;

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 0;
`;
const NumberOfDaysToGenerate = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 0;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/DetailsForGenerateBlock/GenerateOptions.jsx